import { Link } from '@tanstack/react-router'
import { Home, MapPinOff, Search } from 'lucide-react'

export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-green-50 to-emerald-100 px-4">
      <div className="w-full max-w-md animate-[fadeIn_0.5s_ease-in-out] text-center">
        <div className="mb-8">
          <div className="mb-4 flex justify-center">
            <MapPinOff className="animate-pulse text-red-500" size={80} />
          </div>

          <div className="mb-4 text-6xl font-bold text-red-600">404</div>

          <h1 className="mb-2 text-2xl font-bold text-gray-800">
            Halaman Tidak Ditemukan
          </h1>

          <p className="mb-6 leading-relaxed text-gray-600">
            Halaman yang Anda cari mungkin telah dihapus, diubah namanya, atau
            tidak pernah ada. Periksa kembali alamat URL yang Anda masukkan.
          </p>
        </div>

        <div className="space-y-4">
          <Link
            to="/dashboard"
            className="bg-primary hover:bg-primary/80 flex w-full transform items-center justify-center gap-2 rounded-lg px-6 py-3 font-semibold text-white transition-all duration-200 hover:scale-105"
          >
            <Home size={18} />
            Ke Dashboard
          </Link>

          <Link
            to="/"
            className="border-primary text-primary hover:bg-primary/10 flex w-full items-center justify-center gap-2 rounded-lg border-2 bg-white px-6 py-3 font-semibold transition-colors duration-200"
          >
            <Search size={18} />
            Ke Halaman Utama
          </Link>
        </div>

        <div className="mt-8 text-sm text-gray-500">
          Kode Error:{' '}
          <span className="rounded bg-green-100 px-2 py-1 font-mono text-green-700">
            NOT_FOUND
          </span>
        </div>
      </div>
    </div>
  )
}
